const productMap = {
  '/': '',
  '/hotels': 'hotel',
  '/flights': 'air',
  '/vacationpackages': 'bundle',
  '/vip': '',
  vacations: 'bundle',
  hotels: 'hotel',
  flights: 'air',
  cars: 'car',
  cruises: 'cruise'
} as const

type ProductMap = keyof typeof productMap

export default function mapProduct(product: string) {
  return productMap[product as ProductMap]
}
